import React, { Component } from "react";
import PropTypes from "prop-types";
import { View, StyleSheet, Platform } from "react-native";
import Text from "../TextFont";
import { connect } from "react-redux";
import * as CONSTS from "../../../assets/consts";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import { IconButton } from "../../components_v2/Buttons";
import { translate } from "../../locales/translate";
import { englishToPersianNumber } from "../../util";
import FontAwesomeIcon from "../FontAwesomeIcon";
import Theme from "../../argon-ui/Theme";
/**@augments{Component<Props,state>} */
class UserBalance extends Component {
  static propTypes = {
    model: PropTypes.shape({
      name: PropTypes.string.isRequired,
      configs: PropTypes.shape(),
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUnitShown: true,
      isUserShown: true,
      unitBalances: [], // array of {areaId, areaName, balance}
      userBalance: 0,
      PriceUnit: "",
      minValueToShow: 0,
      minUserBalanceToWarning: 0,
      minUnitBalanceToWarning: 0,
      closable: false,
      apiUrl: "",
      checkAccessApiUrl: "",
      showFullSize: false,
    };
  }

  async componentDidMount() {
    let { model } = this.props;
    if (model && model.configs) {
      let {
        apiUrl,
        checkAccessApiUrl,
        closable,
        minValueToShow,
        minUserBalanceToWarning,
        minUnitBalanceToWarning,
        priceUnit,
      } = model.configs;

      this.setState({
        apiUrl,
        checkAccessApiUrl,
        closable,
        minValueToShow,
        minUserBalanceToWarning,
        minUnitBalanceToWarning,
        priceUnit,
      });

      try {
        var access_token = this.props.appReducer?.currentServer.accessToken;
        var _baseApiUrl = this.props.appReducer.serverUrl;
        var fullApiUrl = _baseApiUrl + apiUrl;
        var userInUnitApi = _baseApiUrl + checkAccessApiUrl;

        // user balance
        var userBalance = await this.callGetUserBalanceApi(
          access_token,
          fullApiUrl
        );

        // unit balances
        var unitBalances = [];
        // areas allowed to increase credit
        var allowedAreas = await this.callUserCanIncreaseApi(
          access_token,
          userInUnitApi
        );

        for (let i = 0; i < allowedAreas.length; i++) {
          const area = allowedAreas[i];
          var unitApiUrl = `${fullApiUrl}?unitCode=${area.areaId}`;

          var unitBalance = await this.callGetUserBalanceApi(
            access_token,
            unitApiUrl,
            area.areaId
          );
          if (unitBalance < this.state.minValueToShow) {
            unitBalances.push({
              areaId: area.areaId,
              areaName: area.areaName,
              balance: unitBalance,
            });
          }
        }

        this.setState({ userBalance, unitBalances, isLoading: false });
      } catch (e) {
        console.log(e);
        this.setState({ isLoading: false });
      }
    }
  }

  callGetUserBalanceApi = (access_token, fullApiUrl, areaId) => {
    return new Promise((resolve, reject) => {
      fetch(fullApiUrl, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      })
        .then((res) => res.json())
        .then((resj) => {
          if (resj) {
            let { userBalance, unitBalance } = resj;
            if (areaId) {
              resolve(unitBalance);
            } else {
              resolve(userBalance);
            }
          }
        })
        .catch((e) => {
          console.log("Error in Widgets.UserBalance", e);
          reject(e);
        });
    });
  };

  /**will return an array of {areaId,areaName} user can increase credit */
  callUserCanIncreaseApi = (access_token, fullApiUrl, areaId) => {
    return new Promise((resolve, reject) => {
      fetch(fullApiUrl, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      })
        .then((res) => res.json())
        .then((resj) => {
          if (resj && Array.isArray(resj)) {
            var allowedAreas = [];
            for (var i in resj) {
              let { numUnitRef, strUnitName, boolIncreaseUnitCredit } = resj[i];
              if (boolIncreaseUnitCredit)
                allowedAreas.push({
                  areaId: numUnitRef,
                  areaName: strUnitName,
                });
            }
            resolve(allowedAreas);
          } else {
            resolve([]); // return empty list
          }
        })
        .catch((e) => {
          console.log("Error in Widgets.UserBalance", e);
          reject(e);
        });
    });
  };

  handleOnReChargePress = () => {
    typeof this.props.onAction === "function" &&
      this.props.onAction(CONSTS.WIDGET_ACTIONS.RECHARGE);
  };

  renderUserBalance() {
    if (this.state.userBalance > this.state.minValueToShow) return null;

    return this.renderBalanceView(
      0, // key
      translate("widgets.userBalance.yourCredit"),
      this.state.userBalance || 0,
      this.state.priceUnit,
      this.state.closable,
      this.state.userBalance <= this.state.minUserBalanceToWarning,
      () => {
        this.setState({ isUserShown: false });
      }
    );
  }

  renderUnitBalance(areaId, areaName, balance) {
    return this.renderBalanceView(
      areaId, // key
      translate("widgets.userBalance.unitCredit") + "(" + areaName + ")",
      balance || this.state.unitBalance || 0,
      this.state.priceUnit,
      this.state.closable,
      balance <= this.state.minUnitBalanceToWarning,
      () => {
        var unitBalances = [...this.state.unitBalances];
        for (var i in unitBalances) {
          if (unitBalances[i].areaId == areaId) {
            unitBalances.splice(i, 1);
            this.setState({ unitBalances });
            break;
          }
        }
        //this.setState({ isUnitShown: false });
      }
    );
  }

  renderBalanceView(
    key = 0,
    title = "",
    amount = 0,
    unit = "",
    closable = false,
    showWarning = false,
    onClose = () => {}
  ) {
    return (
      <View style={[styles.balanceContainer, { padding: 10 }]} key={key}>
        <View style={styles.messageContainer}>
          <View
            style={[
              {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              },
              !showWarning && Platform.OS === "web"
                ? { marginLeft: 30 }
                : { marginRight: 30 },
            ]}
          >
            <Text>{title}:</Text>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text
                style={[
                  styles.priceHolder,
                  { color: showWarning ? "#ff0000" : "#000" },
                ]}
              >
                {englishToPersianNumber(amount, ",")}{" "}
              </Text>
              <Text style={{ fontSize: 12 }}>{unit}</Text>
            </View>
          </View>
          {showWarning && (
            <View style={{ flexDirection: "row", marginBottom: 20 }}>
              <Text style={styles.reChargeText}>
                {translate("widgets.userBalance.rechargeWarning")}{" "}
                <Text
                  style={styles.reChargeTextButton}
                  onPress={this.handleOnReChargePress}
                >
                  {translate("widgets.userBalance.rechargeWarningButton")}
                </Text>{" "}
                {translate("widgets.userBalance.rechargeWarningRest")}
              </Text>
            </View>
          )}
          <View
            style={[
              { position: "absolute", bottom: -4 },
              Platform.OS === "web" ? { left: 0 } : { right: 0 },
            ]}
          >
            {closable && (
              <IconButton
                onPress={() => {
                  onClose && typeof onClose === "function" && onClose();
                }}
                style={styles.closeIconButton}
                icon={{
                  code: faCharCodes.faTimesCircle,
                  style: {
                    fontFamily: "FontAwesomeProLight",
                    fontSize: 24,
                    color: "#3880ff",
                  },
                }}
              />
            )}
          </View>
        </View>
      </View>
    );
  }

  renderSummary() {
    var showWarning =
      this.state.userBalance <= this.state.minUserBalanceToWarning ||
      this.state.unitBalances.some(
        (ub) => ub.balance <= this.state.minUnitBalanceToWarning
      );
    if (!showWarning) return null;
    return (
      <View style={[styles.balanceContainer, { padding: 6 }]}>
        <View style={styles.messageContainer}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <FontAwesomeIcon
              icon={faCharCodes.faWallet}
              size={13}
              color={Theme.COLORS.MUTED}
            />
            <Text style={{ marginHorizontal: 5, fontSize: 12 }}>
              {translate("widgets.userBalance.creditStatus")}:
            </Text>
            <Text style={[styles.priceHolder, { color: Theme.COLORS.ERROR }]}>
              {translate("widgets.userBalance.indebted")}
            </Text>
          </View>
        </View>
        {/* {closable && ()} */}
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <IconButton
            onPress={() => {
              this.setState({ showFullSize: true });
            }}
            style={[styles.closeIconButton]}
            icon={{
              code: faCharCodes.faCaretSquareDown,
              style: {
                fontFamily: "FontAwesomeProLight",
                fontSize: 24,
                color: "#3880ff",
              },
            }}
          />
          <IconButton
            onPress={() => {
              this.setState({ isUserShown: false, unitBalances: [] });
              // onClose && typeof onClose === "function" && onClose();
            }}
            style={styles.closeIconButton}
            icon={{
              code: faCharCodes.faTimesSquare,
              style: {
                fontFamily: "FontAwesomeProLight",
                fontSize: 24,
                color: "#3880ff",
              },
            }}
          />
        </View>
      </View>
    );
  }

  render() {
    if (this.state.isLoading) return null;
    if (!this.state.showFullSize) return this.renderSummary();
    return (
      <View>
        {/* {this.state.isUnitShown &&
          this.state.unitBalance >= this.state.minValueToShow &&
          this.renderUnitBalance()} */}
        {this.state.unitBalances != undefined &&
          this.state.unitBalances.map((unitBalance) => {
            return this.renderUnitBalance(
              unitBalance.areaId,
              unitBalance.areaName,
              unitBalance.balance
            );
          })}
        {this.state.isUserShown &&
          this.state.userBalance >= this.state.minValueToShow &&
          this.renderUserBalance()}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  balanceContainer: {
    flexDirection: "row",
    backgroundColor: "#deeaff",
    padding: 10,
    borderRadius: 5,
    alignItems: "center",
    marginVertical: 5,
  },
  messageContainer: {
    flex: 1,
  },
  priceHolder: {
    textAlign: "left",
    writingDirection: "rtl",
    paddingHorizontal: 3,
    fontSize: 12,
  },
  closeIconButton: {
    width: 27,
    height: 30,
    alignItems: "center",
    paddingEnd: -2,
    justifyContent: "center",
    // marginStart: 5,
  },
  reChargeText: { color: "#ff8c00", fontSize: 12 },
  reChargeTextButton: {
    color: "#fff",
    backgroundColor: "#ff7700",
    borderColor: "#ff4800",
    shadowColor: "#4a1500",
    shadowRadius: Platform.OS == "web" ? 3 : 0.5,
    shadowOpacity: Platform.OS == "web" ? 0.3 : 0.8,
    shadowOffset: { width: 3, height: 3 },
    elevation: 4,
    borderWidth: 1,
    borderRadius: 6,
    paddingHorizontal: 6,
    marginHorizontal: 4,
  },
});

function mapStateToProps(state) {
  return {
    areaReducer: state.AreaReducer,
    appReducer: state.AppReducer,
  };
}

export default connect(mapStateToProps)(UserBalance);
